import styles from './Header.module.scss';
import { CloseIcon } from '../../../../lib/icons/CloseIcon';
import { MobileMenuIcon } from '../../../../lib/icons/MobileMenuIcon';
import { useAttributeLabel } from '../../../../lib/hooks/labels';
import { ATTRIBUTES } from '../../../../lib/constants/attributes';
import { HEADER_LABEL_KEYS, COMMON_LABELS } from '../../../../lib/constants/labelKeys';
import { useHeaderContext } from '../../../../lib/context/HeaderContext';

type ExpandMobileButtonProps = {
  controllableId: string;
};

const ExpandMobileButton = ({ controllableId }: ExpandMobileButtonProps) => {
  const { showMobileMenu, setShowMobileMenu } = useHeaderContext();

  const expandMobileMenuLabel = useAttributeLabel(
    ATTRIBUTES.ARIA_LABEL,
    HEADER_LABEL_KEYS.MOBILE_MENU_EXPAND_BUTTON_ARIA_LABEL,
  );

  const collapseMobileMenuLabel = useAttributeLabel(ATTRIBUTES.ARIA_LABEL, COMMON_LABELS.DIALOG.CLOSE);

  return (
    <button
      aria-expanded={showMobileMenu}
      aria-controls={controllableId}
      className={styles.mobileButton}
      {...(showMobileMenu ? collapseMobileMenuLabel : expandMobileMenuLabel)}
      onClick={() => setShowMobileMenu(!showMobileMenu)}
    >
      {showMobileMenu ? <CloseIcon variant="secondary" /> : <MobileMenuIcon variant="secondary" />}
    </button>
  );
};

export default ExpandMobileButton;
